<template>
  <div class="mannequin" @mouseover="hover = true" @mouseleave="hover = false">
    <div v-if="highlight">
      <div class="shape-image-highlight">
        <img :src="shape.image" />
      </div>
    </div>
    <div v-else>
      <div class="shape-image">
        <img :src="shape.image" />
      </div>
    </div>
    <div 
      class="hover-mobile hover-container"
      :class="{ 
        'hover-left-desktop': shape.token == 'yellow' || shape.token == 'blue',
        'hover-right-desktop': shape.token == 'red' || shape.token == 'orange' || shape.token == 'green' || shape.token == 'purple',
        'hover-left-tablet': shape.token == 'orange' || shape.token == 'purple' || shape.token == 'yellow',
        'hover-right-tablet': shape.token == 'red' || shape.token == 'blue' || shape.token == 'green'
      }">
      <div 
        class="hover-text animate__animated" 
        :class="{ 
          animate__fadeInLeft: shape.token == 'red' || shape.token == 'orange' || shape.token == 'green' || shape.token == 'purple', 
          animate__fadeInRight: shape.token == 'yellow' || shape.token == 'blue' 
        }" 
        v-if="hover">
        <div v-for="(feature, index) in shape.features" :key="index">
          <ul class="feature"><li v-html="feature"></li></ul>
        </div>
        <button @click="selected">select</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShapeMannequin",
  props: {
    shape: Object,
    highlight: Boolean,
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    selected() {
      this.$emit("shape-selected");
    }
  },
};
</script>

<style lang="scss" scoped>
.mannequin {
  position: relative;
  text-align: center;
  margin: 1%;
  font-weight: 900;
  &:hover {
    cursor: pointer;
    border: solid 1px gray;
  }
  .shape-image {
    background-color: #F1CCBE;
    width: 100%;
    img {
      height: 180px;
    }
  }
  .shape-image-highlight {
    background-color: #e49b81;
    img {
      height: 180px;
    }
  }
  .hover-container {
    .hover-text {
      background-color: white;
      padding: 10px;
      height: 189px;
      border: solid 1px gray;
      button {
        background-color: black;
        color: white;
        border: none;
        font-family: 'Helvetica';
        padding: 10px 60px;
        margin: 20px 0px;
        border: solid 1px black;
        &:hover {
          cursor: pointer;
          background-color: white;
          color: black;
        }
      }
    }
  }
  .hover-right-desktop {
    position: absolute;
    z-index: 5;
    top: 0;
    right: -100%;
    width: 100%;
  }
  .hover-left-desktop {
    position: absolute;
    z-index: 5;
    top: 0;
    left: -100%;
    width: 100%;
  }
  .feature {
    list-style: disc;
    padding-left: 20px;
    li {
      text-align: left;
      font-size: 14px;
    }
  }
  .feature-list {
    font-size: 1rem;
    font-weight: 500;
    max-width: 700px;
    margin: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center !important;
    width: 100%;
    padding-top: 0.15em;
    padding-bottom: 0.15em;
    background: beige;
    li.feature {
      font-size: 0.25em;
      color: black;
    }
  }
}
@media (max-width: 762px) {
  .mannequin {
    // padding-left: 2em;
    .shape-image {
      max-height: 320px;
    }
  }
}
@media (max-width: 579px) {
  .hover-left-tablet {
    left: -100% !important;
  }
  .hover-right-tablet {
    left: 100% !important;
  }
}
@media (max-width: 399px) {
  .hover-mobile {
    position: relative !important;
    top: 100% !important;
    left: 0% !important;
  }

  .hover-text {
    height: 150px;
    border: none;
  }
}
</style>

